import { Typography } from "@mui/material";
import { useLabel } from "../../../../../hooks";

export const Subtitle = (props: { labelKey: string }) => {
    const label = useLabel(props.labelKey);
    return <Typography variant="h4" style={{marginBottom: 20, marginTop: 30}}>{label}</Typography>
};